/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OWGameResponse } from './OWGameResponse';
import {
    OWGameResponseFromJSON,
    OWGameResponseFromJSONTyped,
    OWGameResponseToJSON,
    OWGameResponseToJSONTyped,
} from './OWGameResponse';

/**
 * 
 * @export
 * @interface HeroGame
 */
export interface HeroGame {
    /**
     * 
     * @type {OWGameResponse}
     * @memberof HeroGame
     */
    game: OWGameResponse;
    /**
     * True when the slot came from the weekly platform top five rather than the user's own play history.
     * @type {boolean}
     * @memberof HeroGame
     */
    seeded: boolean;
}

/**
 * Check if a given object implements the HeroGame interface.
 */
export function instanceOfHeroGame(value: object): value is HeroGame {
    if (!('game' in value) || value['game'] === undefined) return false;
    if (!('seeded' in value) || value['seeded'] === undefined) return false;
    return true;
}

export function HeroGameFromJSON(json: any): HeroGame {
    return HeroGameFromJSONTyped(json, false);
}

export function HeroGameFromJSONTyped(json: any, ignoreDiscriminator: boolean): HeroGame {
    if (json == null) {
        return json;
    }
    return {
        
        'game': OWGameResponseFromJSON(json['game']),
        'seeded': json['seeded'],
    };
}

export function HeroGameToJSON(json: any): HeroGame {
    return HeroGameToJSONTyped(json, false);
}

export function HeroGameToJSONTyped(value?: HeroGame | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'game': OWGameResponseToJSON(value['game']),
        'seeded': value['seeded'],
    };
}

